import { core } from '@/core'
import Basic from '@basic'

const util = {
  template: {
    popup() {
      return $(`
      <div class="popup-window">
        <div id="inner" class="popup-inner" style="height:250px;">
          <div id="aside" class="popup-aside">
            <div id="btnHide" class="popup-aside-label">
              <i class="fa fa-list" aria-hidden="true"></i>
            </div>
            <div id="btnShow" class="popup-aside-label" style="display: none;">
              <i class="fa fa-list-alt" aria-hidden="true"></i>
            </div>
            <div id="title" class="popup-aside-title"> 高级搜索 </div>
          </div>
          <div class="popup-content">
            <div id="body" class="popup-body"></div>
          </div>
        </div>
      </div>`)
    }
  },
  updater: {
    slot(value, opt, tar, node) {
      if (value) {
        const { body } = tar.members
        body.empty().append(value)
      }
    },
    show(value, opt, tar, node) {
      if (value) {
        tar.handleShow()
      } else {
        tar.handleHide()
      }
    }
  }
}

export default class Popup extends Basic {
  constructor(opt) {
    super(opt)
    const def = {
      height: '100vh',
      width: '80vw'
    }
    this.defaults = {
      slot: '',
      show: false
    }
    this.events = {}
    this.settings = Object.assign({}, def, this.defaults, opt)
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.popup(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    const { clearIcon } = this.members
    this.clearAnchor = clearIcon && clearIcon.parent()
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  destroyed() {
    this.unit.empty().remove()
  }

  bindInput() {
    const { btnHide, btnShow } = this.members
    btnHide.click($.proxy(this.handleHide, this))
    btnShow.click($.proxy(this.handleShow, this))
  }

  handleHide() {
    const { body, inner } = this.members
    body.hide()
    inner.css({ width: '50px' })
    setTimeout($.proxy(this.hideOver, this), 250)
  }

  handleShow() {
    const height = this.settings.height
    const { inner, title } = this.members
    title.show()
    inner.css({ height })
    setTimeout($.proxy(this.showOver, this), 250)
  }

  showOver() {
    const width = this.settings.width
    const { btnHide, btnShow, inner } = this.members
    btnHide.show()
    btnShow.hide()
    inner.css({ width })
    setTimeout($.proxy(this.showOver2, this), 250)
  }

  showOver2() {
    const { body } = this.members
    body.show()
  }

  hideOver() {
    const { btnHide, btnShow, title, inner } = this.members
    btnHide.hide()
    btnShow.show()
    inner.css({ height: '250px' })
  }
}
